var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1014_1273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52015 5.93401L1.39315 2.80801L2.80815 1.39301L22.6072 21.193L21.1922 22.607L17.8822 19.297C16.1234 20.4126 14.0829 21.0033 12.0002 21C6.60815 21 2.12215 17.12 1.18115 12C1.61118 9.67072 2.78278 7.5429 4.52115 5.93401H4.52015ZM14.7572 16.172L13.2932 14.708C12.7332 14.9759 12.1039 15.0635 11.4921 14.9588C10.8802 14.854 10.316 14.5621 9.87702 14.1231C9.43809 13.6842 9.14612 13.1199 9.04137 12.5081C8.93662 11.8962 9.02424 11.267 9.29215 10.707L7.82815 9.24301C7.19187 10.2045 6.90742 11.3563 7.02298 12.5035C7.13854 13.6507 7.647 14.7226 8.46227 15.5379C9.27754 16.3532 10.3495 16.8616 11.4967 16.9772C12.6438 17.0927 13.7957 16.8083 14.7572 16.172V16.172ZM7.97415 3.76001C9.22115 3.27001 10.5802 3.00001 12.0002 3.00001C17.3922 3.00001 21.8782 6.88001 22.8192 12C22.5127 13.6657 21.824 15.2376 20.8072 16.592L16.9472 12.732C17.0618 11.9596 16.994 11.1711 16.7491 10.4297C16.5042 9.68821 16.089 9.01442 15.5369 8.46227C14.9847 7.91013 14.311 7.49498 13.5695 7.25008C12.828 7.00518 12.0395 6.93735 11.2672 7.05201L7.97415 3.76101V3.76001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_1273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEye);
export default __webpack_public_path__ + "static/media/hideEye.25dda2b04d2ce0275a96ef3a2f1491fb.svg";
export { ForwardRef as ReactComponent };